// extracted by mini-css-extract-plugin
module.exports = {"container":"page_container-module__container--1wBXN"};